import { Button } from "@mui/material";
import axios from "axios";
import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import NextArrow from "../../accoutrements/NextArrow";
import { sendCaptchaVerification } from "@/src/utils/helpers";
import Link from "next/link";

export interface RegisterProps {
  title?: string;
  subTitle?: string;
  buttonText?: string;
  arrow?: boolean;
  onSuccess?: (id: string, email: string) => void;
}

const Register = ({
  title = "Register",
  subTitle = "",
  buttonText,
  arrow = false,
  onSuccess,
}: RegisterProps) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const [isVerified, setIsverified] = useState<boolean>(true);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<null | string>(null);
  const [errorType, setErrorType] = useState<null | string>(null);

  const [loginFields, setLoginFields] = useState({
    email: "",
    username: "",
    password: "",
  });

  async function handleCaptchaSubmission(token: string | null) {
    // Server function to verify captcha
    await sendCaptchaVerification(token || "")
      .then((resp) => {
        setIsverified(resp);
      })
      .catch((e) => {
        setIsverified(false);
      });
  }

  const onFormSubmit = async (event: any) => {
    event.preventDefault();
    setLoading(true);
    //@ts-ignore
    const wpAccount = await axios.post("/api/auth/register", {
      username: loginFields.username,
      email: loginFields.email,
      password: loginFields.password,
    });

    const userId = wpAccount.data?.data?.createUser?.user?.userId ?? "";
    if (!wpAccount.data.data) {
      if (
        wpAccount.data?.errors?.message?.includes(
          "username is already registered"
        )
      ) {
        setErrorMessage("Username already registered - try logging in");
        setErrorType("Login");
      } else if (
        wpAccount.data?.errors?.message?.includes(
          "email address is already registered"
        )
      ) {
        setErrorMessage("Email is already registered - try logging in");
        setErrorType("Login");
      } else {
        setErrorMessage(wpAccount.data?.errors?.message);
      }

      setLoading(false);
    } else {
      // Successfull - need to then login and redirect?
      const loginReq = await axios
        .post("/api/login", {
          username: loginFields.username,
          password: loginFields.password,
        })
        .catch((e) => e);
      if (loginReq.data?.success) {
        // TODO - add the id + email to the onsuccess
        onSuccess && onSuccess(userId, "");
      }
    }
  };

  const handleOnChange = (event: any) => {
    setLoginFields({ ...loginFields, [event.target.name]: event.target.value });
  };

  return (
    <div className="login-form rounded-xl">
      <form onSubmit={onFormSubmit} className="mb-4 flex flex-col">
        <div className="flex flex-col gap-2">
          <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
            Email:
            <input
              type="email"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              name="email"
              value={loginFields.email}
              onChange={handleOnChange}
            />
          </label>
          <label className="leading-7 text-sm text-gray-600">
            Username:
            <input
              type="text"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              name="username"
              value={loginFields.username}
              onChange={handleOnChange}
            />
          </label>

          <label className="leading-7 text-sm text-gray-600">
            Password:
            <input
              type="password"
              className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              name="password"
              value={loginFields.password}
              onChange={handleOnChange}
              autoComplete="new-password"
            />
          </label>
        </div>
        <div className={"py-4"}>
          {/* <ReCAPTCHA
            sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ""}
            ref={recaptchaRef}
            onChange={handleCaptchaSubmission}
          /> */}
        </div>
        <Button
          className="text-white bg-scpb-light-blue border-0 py-2 px-8 focus:outline-none hover:bg-scpb-dark-blue rounded text-lg flex relative"
          type="submit"
          disabled={!isVerified}
        >
          {!loading && buttonText ? buttonText : "Register"}
          {loading && `Loading`}
          {arrow && (
            <div className="absolute right-2">
              <NextArrow />
            </div>
          )}
        </Button>
        {loading ? <p>Loading...</p> : errorMessage}
        {errorType === "Login" && (
          <Link href="/login">
            <Button className="text-white bg-scpb-light-blue border-0 py-2 px-8 focus:outline-none hover:bg-scpb-dark-blue rounded text-lg flex relative w-full">
              Login here
            </Button>
          </Link>
        )}
      </form>
    </div>
  );
};

export default Register;
